import logoInnax from "@/assets/img/logo.png";

function getImageUrl(name) {
  return new URL(`../assets/img/${name}`, import.meta.url).href;
}

function houseImage(color) {
  switch (color) {
    case "color-green":
      return getImageUrl("huisje-groen.png");
    case "color-orange":
      return getImageUrl("huisje-oranje.png");
    case "color-red":
      return getImageUrl("huisje-rood.png");
    case "color-grey":
      return getImageUrl("huisje-grijs.png");
    default:
      return null;
  }
}

export { logoInnax, getImageUrl, houseImage };
